import React from "react";
import { Row, Col, Box, Botao, Combo, CampoTexto, Form, Alerta, TipoBotao, TipoAlerta } from "@intechprev/componentes-web";
import { RelacionamentoService, FuncionarioService } from "./../../services";
import { RelacionamentoEntidade } from "./../../entidades";
import { MasterPage } from "../";
import { NumFuncionalidade } from "../MasterPage";
import { reCAPTCHA } from "../../helpers";

interface Props { }

interface State {
  email: string;
  assunto: string;
  listaAssunto: Array<any>;
  mensagem: string;
}

export class Relacionamento extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("relacionamento");

  private page = React.createRef<MasterPage>();
  private form = React.createRef<Form>();
  private alert = React.createRef<Alerta>();

  constructor(props: Props) {
    super(props);

    this.state = {
      email: "",
      assunto: "",
      listaAssunto: [],
      mensagem: "",
    };
  }

  componentDidMount = async () => {
    await this.page.current.alternarLoading();

    var dados = await FuncionarioService.Buscar();
    var listaAssunto = await RelacionamentoService.BuscarListaAssunto();

    this.setState({
      email: dados.DadosPessoais.EMAIL_AUX,
      listaAssunto,
    });

    await this.page.current.alternarLoading();
  };

  validar = async () => {
    await this.alert.current.limparErros();
    await this.form.current.validar();

    if (this.alert.current.state.mensagem.length === 0 && this.alert.current.props.mensagem.length === 0) {
      try {
        this.page.current.alternarLoading();

        const mensagem = new RelacionamentoEntidade();
        mensagem.Email = this.state.email;
        mensagem.Assunto = this.state.assunto;
        mensagem.Mensagem = this.state.mensagem;

        await RelacionamentoService.ValidarEmail(mensagem.Email);

        let mensagemResultado = await RelacionamentoService.Enviar(mensagem);
        alert(mensagemResultado);
        this.limparCampos();

        this.page.current.alternarLoading();
      } catch (e) {
        const err: any = e;
        if (err.response) alert(err.response.data);
        else console.error(err);
      }
    }
  };

  limparCampos = () => {
    this.setState({
      email: "",
      assunto: "",
      mensagem: "",
    });
  };

  render() {
    return (
      <MasterPage Funcionalidade={NumFuncionalidade.FALE_CONOSCO} {...this.props} ref={this.page}>
        <Row>
          <Col>
            <Box titulo={"Envie-nos uma mensagem!"}>
              <Form ref={this.form}>
                <CampoTexto contexto={this} nome={"email"} max={50} valor={this.state.email} titulo={"Seu e-mail"} tipo={"email"} obrigatorio />

                {/* <CampoTexto
                                  contexto={this}
                                  nome={"assunto"}
                                  max={50}
                                  valor={this.state.assunto}
                                  label={"Assunto"}
                                  obrigatorio
                                /> */}

                <Combo
                  contexto={this}
                  nome={"assunto"}
                  valor={this.state.assunto}
                  textoVazio={"Selecione um assunto"}
                  nomeMembro={"TXT_ASSUNTO"}
                  valorMembro={"OID_ASSUNTO"}
                  opcoes={this.state.listaAssunto}
                  titulo={"Assunto"}
                  obrigatorio
                />

                <CampoTexto
                  contexto={this}
                  nome={"mensagem"}
                  max={4000}
                  textarea
                  valor={this.state.mensagem}
                  rows={10}
                  titulo={"Mensagem"}
                  obrigatorio
                />

                <Botao titulo={"Enviar"} tipo={TipoBotao.primary} submit onClick={this.validar} />
                <br />
                <br />
                <Alerta ref={this.alert} padraoFormulario tipo={TipoAlerta.danger} tamanho={"6"} />
              </Form>
            </Box>
          </Col>
        </Row>
      </MasterPage>
    );
  }
}
